import { Instagram, MapPin } from "lucide-react";
import { BUSINESS } from "../data/products";

const NAV = [
  { label: "Home", id: "home" },
  { label: "Products", id: "products" },
  { label: "Reviews", id: "reviews" },
  { label: "About", id: "about" },
  { label: "Visit Us", id: "visit" },
  { label: "Contact", id: "contact" },
];

export const Footer = () => {
  const go = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer
      data-testid="footer"
      className="border-t border-white/10 bg-[#0a0a0b] pt-16 pb-10 px-6 md:px-12"
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-heading text-2xl font-semibold">
            <span className="text-gradient">SMOK CITY</span>
          </div>
          <p className="mt-4 text-zinc-400 max-w-sm leading-relaxed">
            Your ultimate vape shop & smoke store on West Trenton Avenue in
            Morrisville. Disposable vapes, tobacco, smoking accessories, kratom,
            and THCA—featuring top brands and innovative devices like the Solaris
            25000 and Flair Ultra, all available in-store.
          </p>
          <a
            href={BUSINESS.mapsLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-maps-link"
            className="mt-5 inline-flex items-center gap-2 text-sm text-[#00e5ff] hover:underline"
          >
            <MapPin size={15} /> {BUSINESS.addressLine1}, {BUSINESS.addressLine2}
          </a>
          <div className="flex gap-3 mt-6">
            <a
              href={BUSINESS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              aria-label="Instagram"
              className="w-10 h-10 rounded-full glass flex items-center justify-center text-zinc-300 hover:text-[#00e5ff] hover:-translate-y-0.5 transition"
            >
              <Instagram size={18} />
            </a>
          </div>
        </div>

        <div>
          <div className="text-sm uppercase tracking-widest text-zinc-500 mb-4">
            Explore
          </div>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.id}>
                <button
                  data-testid={`footer-nav-${n.id}`}
                  onClick={() => go(n.id)}
                  className="text-zinc-400 hover:text-white transition text-sm"
                >
                  {n.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-sm uppercase tracking-widest text-zinc-500 mb-4">
            Hours
          </div>
          <ul className="space-y-3 text-sm">
            {BUSINESS.hours.map((h) => (
              <li key={h.day} className="text-zinc-400">
                <div className="text-zinc-300">{h.day}</div>
                <div>{h.time}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-14 pt-8 border-t border-white/10">
        <p
          data-testid="footer-compliance"
          className="text-center text-sm text-zinc-500 max-w-3xl mx-auto"
        >
          Products sold only to adults 21+. Please comply with all federal,
          state, and local laws.
        </p>
        <p className="text-center text-xs text-zinc-600 mt-5">
          © {new Date().getFullYear()} SMOK CITY. All rights reserved.
          Smoke Shop, Vape Shop & Smoke Store · Morrisville, PA.
        </p>
      </div>
    </footer>
  );
};
